import { z } from "zod";

const zReferralSourceSchema = z.enum([
  "WEB_SEARCH",
  "FRIENDS_RECOMMENDATIONS",
  "SOCIAL_NETWORKS",
  "ADVERTISEMENT",
  "OTHER",
]);
const ReferralSourceSchema = zReferralSourceSchema.Values;
type ReferralSourceSchema = z.infer<typeof zReferralSourceSchema>;

const DISCRIMINATOR = "source";

const zReferralInfoSchema = z.discriminatedUnion(DISCRIMINATOR, [
  z.object({
    [DISCRIMINATOR]: zReferralSourceSchema.exclude([ReferralSourceSchema.OTHER]),
  }),
  z.object({
    [DISCRIMINATOR]: z.literal(ReferralSourceSchema.OTHER),
    details: z
      .string()
      .trim()
      .nonempty()
      .max(2 ** 8),
  }),
]);
type ReferralInfoSchema = z.infer<typeof zReferralInfoSchema>;

export { ReferralSourceSchema, zReferralInfoSchema, zReferralSourceSchema };
export type { ReferralInfoSchema };
